import moment from 'moment';
import React, { Component } from "react";
import 'react-block-ui/style.css';
import Datetime from 'react-datetime';
import LoadingIndicator from '../Components/LoadingIndicator/LoadingIndicator';
import ReportsService from '../utils/ReportsService';
import UsersService from '../utils/UsersService';

const StatTable = (props) => {
  const { title, showSeminar, totals } = props
  const baseWidth = 600
  return (
    <div style={{
      width: '100%', padding: 20, margin: 10, background: '#fefefe', border: '1px solid #ccc'
    }}>
      <h4 style={{ marginTop: 0 }}>{title}</h4>
      <table className='table table-bordered'>
        <thead>
          <tr>
            <th style={{ width: 250 }}>Event</th>
            <th style={{ width: 100 }}>Total</th>
            <th style={{ width: baseWidth + 100 }}>Percentage</th></tr>
        </thead>
        <tbody>
          {showSeminar && <tr>
            <td>Seminar Registrations</td>
            <td>{totals.flags.seminar_registration}</td>
            <td style={{
              width: baseWidth
            }}>
              <div style={{
                height: 24,
                width: baseWidth / 100 * totals.percentages.seminar_registration,
                background: 'rgb(110, 148, 185)',
              }}></div>{totals.percentages.seminar_registration}%
            </td>
          </tr>}
          {showSeminar && <tr>
            <td>Seminar Attended</td>
            <td>{totals.flags.seminar_attended}</td>
            <td style={{
              width: baseWidth
            }}>
              <div style={{
                display: 'inline-block',
                height: 24,
                width: baseWidth / 100.0 * totals.percentages.seminar_attended,
                background: 'rgb(110, 148, 185)',
              }}></div>{totals.percentages.seminar_attended}%
            </td>
          </tr>}
          <tr>
            <td>TCS Booked</td>
            <td>{totals.flags.tcs_booked}</td>
            <td style={{
              width: baseWidth
            }}>
              <div style={{
                display: 'inline-block',
                height: 24,
                width: baseWidth / 100.0 * totals.percentages.tcs_booked,
                background: 'rgb(110, 148, 185)',
              }}></div>{totals.percentages.tcs_booked}%
            </td>
          </tr>
          <tr>
            <td>TCS Confirmed</td>
            <td>{totals.flags.tcs_confirmed}</td>
            <td style={{
              width: baseWidth
            }}>
              <div style={{
                display: 'inline-block',
                height: 24,
                width: baseWidth / 100.0 * totals.percentages.tcs_confirmed,
                background: 'rgb(110, 148, 185)',
              }}></div>{totals.percentages.tcs_confirmed}%
            </td>
          </tr>
          <tr>
            <td>TCS Presented</td>
            <td>{totals.flags.tcs_presented}</td>
            <td style={{
              width: baseWidth
            }}>
              <div style={{
                display: 'inline-block',
                height: 24,
                width: baseWidth / 100.0 * totals.percentages.tcs_presented,
                background: 'rgb(110, 148, 185)',
              }}></div>{totals.percentages.tcs_presented}%
            </td>
          </tr>
          <tr>
            <td>Sale Made</td>
            <td>{totals.flags.sale_made}</td>
            <td style={{
              width: baseWidth
            }}>
              <div style={{
                display: 'inline-block',
                height: 24,
                width: baseWidth / 100.0 * totals.percentages.sale_made,
                background: 'rgb(110, 148, 185)',
              }}></div>{totals.percentages.sale_made}%
            </td>
          </tr>
          <tr>
            <td>Total Sale Value</td>
            <td>${parseInt(totals.total_sale_value).toLocaleString()}</td>
            <td style={{
              width: baseWidth
            }}></td>
          </tr>
          <tr>
            <td>Average Sale Value</td>
            <td>${parseInt(totals.average_sale_value).toLocaleString()}</td>
            <td style={{
              width: baseWidth
            }}></td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}


class ReportingFunnels extends Component {
  constructor(props) {
    super(props);
    const defaultFilter = {
      completed: 'true',
      sale_made_by: '',
      region: '',
      date_field: 'created_at',
      start_date: moment().subtract(1, 'month').format("DD MMM YYYY"),
      end_date: moment().subtract(1, 'day').format("DD MMM YYYY")
    }
    this.state = {
      filter: defaultFilter,
      data: null,
      coaches: [],
      currentPage: 1,
      totalPages: 1,
      per: 50,
      view: props.view
    };

    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.dateFilterChanged = this.dateFilterChanged.bind(this);
  }

  componentDidMount() {
    this.setState({ loadingInProgress: true }, () => {
      this.fetchItems()
      this.fetchCoaches()
      this.fetchVenues()
    })
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.view !== prevProps.view) {
      const filter = {
        view: this.props.view,
        completed: 'true',
        sale_made_by: '',
        region: '',
        date_field: 'created_at',
        start_date: moment().subtract(1, 'month').format("DD MMM YYYY"),
        end_date: moment().subtract(1, 'day').format("DD MMM YYYY")
      }
      this.setState({ filter: filter, currentPage: 1 }, this.fetchItems)
    }
  }

  handleFilterChange(event) {
    let filter = { ...this.state.filter };
    filter[event.target.id] = event.target.value;
    this.setState({ filter: filter }, this.fetchItems);
  }

  dateFilterChanged(field, value) {
    let filter = { ...this.state.filter };
    filter[field] = value.format("DD MMM YYYY");
    this.setState({ filter: filter, currentPage: 1 }, this.fetchItems);
  }

  fetchItems() {
    this.setState({ loadingInProgress: true });
    ReportsService.funnels({ filter: this.state.filter, page: this.state.currentPage, per: this.state.per }).then(data => {
      this.setState({ loadingInProgress: false, data: data });
    });
  }

  fetchCoaches = () => {
    UsersService.allUsers().then(data => {
      this.setState({ coaches: data.filter((c) => c.roles.includes('tcs_coach')).sort((a, b) => (a.name > b.name) ? 1 : -1) })
    });
  }

  fetchVenues = () => {
    ReportsService.venues().then(data => {
      this.setState({ venues: data })
    });
  }

  render() {
    if (!this.state.data || !this.state.coaches || !this.state.venues) return null

    return (
      <LoadingIndicator loadingInProgress={this.state.loadingInProgress}>
        <div>
          <div style={{ marginBottom: "10px" }}>
            <div style={{ display: 'inline-block', marginRight: 10 }}>
              <select
                id="sale_made_by"
                value={this.state.filter.sale_made_by}
                onChange={this.handleFilterChange}
              >
                <option value="">(any sales representative)</option>
                {this.state.coaches.map(coach => (
                  <option key={coach.email} value={coach.email}>
                    {coach.name}
                  </option>
                ))}
              </select>
            </div>

            <div style={{ display: 'inline-block', marginRight: 10 }}>
              <select
                id="region"
                value={this.state.filter.region}
                onChange={this.handleFilterChange}
              >
                <option value="">(any region)</option>
                <option value="ACT">Australian Capital Territory (SSC)</option>
                <option value="NSW">New South Wales (HSC)</option>
                <option value="NT">Northern Territory (NTCET)</option>
                <option value="QLD">Queensland (QCE)</option>
                <option value="SA">South Australia (SACE)</option>
                <option value="TAS">Tasmania (TCE)</option>
                <option value="VIC">Victoria (VCE)</option>
                <option value="WA">Western Australia (WACE)</option>
              </select>
            </div>

            <div style={{ display: 'inline-block', marginRight: 10 }}>
              <select
                id="venue"
                value={this.state.filter.venue}
                onChange={this.handleFilterChange}
              >
                <option value="">(any venue)</option>
                {this.state.venues.map((v) => <option key={v} value={v}>{v}</option>)}
              </select>
            </div>

            <div style={{ display: 'inline-block', marginRight: 10 }}>
              <select
                id="business_stream"
                value={this.state.filter.business_stream}
                onChange={this.handleFilterChange}
              >
                <option value="">(any business stream)</option>
                <option value='seminar'>Seminar</option>
                <option value='web'>Web Booking</option>
                <option value='webinar'>Webinar</option>
                <option value='callcentre'>Call Centre</option>
                <option value='work_experience_directory'>Work Experience Directory</option>
                <option value='free_report'>Free Report</option>
                <option value='seminar_confirmation_call'>Seminar Confirmation Call</option>
                <option value='seminar_no_show'>Seminar No Show Call</option>
                <option value='seminar_attended_didnt_book'>Seminar Attended But Didnt Book</option>
                <option value='referral'>Referral</option>
                <option value='other'>Other</option>
              </select>
            </div>

            <div style={{ display: 'inline-block', marginRight: 10 }}>
              <select
                id="booking_from"
                value={this.state.filter.booking_from}
                onChange={this.handleFilterChange}
              >
                <option value="">(any booking source)</option>
                <option value='seminar'>Seminar</option>
                <option value='web'>Web</option>
                <option value='call_centre'>Call Centre</option>
                <option value='m1office'>M1 Office</option>
              </select>
            </div>

            <div style={{ display: 'inline-block', marginRight: 10 }}>
              <select
                id="completed"
                value={this.state.filter.completed}
                onChange={this.handleFilterChange}
              >
                <option value="true">Only Completed Deals</option>
                <option value='ignore'>Ignore Completed Status</option>
              </select>
            </div>
          </div>
          <div>
            <div style={{ display: 'inline-block', marginRight: 10 }}>
              <Datetime
                inputProps={{ className: '' }}
                onChange={(v) => this.dateFilterChanged('start_date', v)}
                value={this.state.filter.start_date}
                closeOnSelect={true}
                dateFormat="DD MMM YYYY"
                timeFormat={false}
              />
            </div>

            <div style={{ display: 'inline-block', marginRight: 10 }}>
              <Datetime
                inputProps={{ className: '' }}
                onChange={(v) => this.dateFilterChanged('end_date', v)}
                value={this.state.filter.end_date}
                closeOnSelect={true}
                dateFormat="DD MMM YYYY"
                timeFormat={false}
              />
            </div>
            <div style={{ display: 'inline-block', marginRight: 10 }}>
              <select
                id="date_field"
                value={this.state.filter.date_field}
                onChange={this.handleFilterChange}
              >
                <option value="created_at">Created At</option>
                <option value="tcs_at">TCS At</option>
                <option value="date_of_sale">Sale Made At</option>
                <option value="date_completed">Completed At</option>
              </select>
            </div>
          </div>
        </div>

        <StatTable title='Seminar Sales' totals={this.state.data.seminar_totals} showSeminar={true}></StatTable>
        <StatTable title='Direct TCS Sales' totals={this.state.data.tcs_totals} showSeminar={false}></StatTable>
        <StatTable title='Combined Sales' totals={this.state.data.combined_totals} showSeminar={true}></StatTable>

        <h5>Footnotes</h5>
        <ul>
          <li>Not all Deals have Seminar Registrations (this means the funnel relative percentages are wrong)</li>
          <li>Seminar Registration is counted if there is a registration</li>
          <li>Seminar Attended is counted if the Deal was marked as Attended</li>
          <li>TCS Booked is counted if there is a date for a TCS on the deal (even if it was cancelled)</li>
          <li>TCS Confirmed is counted if there is a date for a TCS on the deal (even if it was cancelled)</li>
          <li>TCS Presented is counted if it was marked as Presented</li>
          <li>Sale Made is counted if a Sale Form was completed</li>
          <li>Sale value figures are only applied across this funnel</li>
          <li>If we do not filter in the query by 'only Deals that are completed', then the figures cannot be trusted, as the date you make the qquery at is relevant to the results. Depending on the date field you choose, some deals may not be counted or too many may be counted. In addition some other figures and ratios may be wildly wrong (you would be unwise to compare two queries on this basis, for example salesperson A might show a 30% close rate, salesperson B a 60% close rate even though both had identical close rates if the same query was done in a months time)</li>
        </ul>

      </LoadingIndicator>
    );
  }
}
export default ReportingFunnels
